import * as React from "react";
import styled from "@mui/material/styles/styled";
import { useHistory } from "react-router";
import { NewPasswordWidget } from "user-management/src/components/newPasswordWidget";
//region [[ Styles ]]
const PatientForgotPasswordView = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
}));
//endregion [[ Styles ]]
//region [[ Props ]]
export interface PatientForgotPasswordProps {}
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]
export const PatientForgotPassword = ({
  ...props
}: PatientForgotPasswordProps) => {
  const history = useHistory();
  return (
    <PatientForgotPasswordView>
      <NewPasswordWidget onResetComplete={() => history.push("/login")} />
    </PatientForgotPasswordView>
  );
};
